import { axiosPrivate } from "@app/dashboard/tools/axios/axiosInstance";

export const deleteRole = (roleId: string) => {
  return axiosPrivate.delete(`/dashboard/v1/roles/${roleId}`);
};